import { createEvent, createStore, sample } from 'effector'

export const isVideoQualityAvailabile = createEvent<{
  shouldShowUpgrade: boolean
  minAvailableQuality: number | null
  isRewinded?: boolean
}>()

export const hideInfoUpgradePackageWidget = createEvent()
export const $showInfoUpgradePackageWidget = createStore(false).on(
  hideInfoUpgradePackageWidget,
  () => false
)

export const $minAvailableQuality = createStore<number | null>(null).on(
  hideInfoUpgradePackageWidget,
  () => null
)

export const setIsRewinded = createEvent<boolean>()
export const $isRewinded = createStore<boolean>(false).on(
  setIsRewinded,
  (_, value) => value
)

export const $isVideoBlocked = createStore<boolean>(false).on(
  hideInfoUpgradePackageWidget,
  () => false
)

sample({
  clock: isVideoQualityAvailabile,
  fn: ({ shouldShowUpgrade }) => shouldShowUpgrade,
  target: [$isVideoBlocked, $showInfoUpgradePackageWidget],
})

sample({
  clock: isVideoQualityAvailabile,
  fn: ({ minAvailableQuality }) => minAvailableQuality,
  target: [$minAvailableQuality],
})
